import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpParams } from '@angular/common/http';
import { DatePipe } from '@angular/common';
import { Subject } from 'rxjs';
import { CommonService } from '../../common.service';
import { NgxSpinnerService } from "ngx-spinner";
import { CommonVariablesService } from '../../common-variables.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-roe-master',
  templateUrl: './roe-master.component.html',
})
export class RoeMasterComponent implements OnInit {
  ROEMasterForm: FormGroup;
  displayRoeMasterResponse: any;
  dtTrigger: Subject<any> = new Subject();
  dtOptions: any;
  submitted = false;
  btnAddShow = false;
  btnUpdateShow = true;
  ROEMasterFormValue: any;
  countryList: any = [];
  roeID: any;
  isViewMode: boolean;

  constructor(
    private formBuilder: FormBuilder,
    private commonService: CommonService,
    private datePipe: DatePipe,
    private commonVariablesService: CommonVariablesService,
    private spinner: NgxSpinnerService
  ) { }

  ngOnInit() {
	window.localStorage.setItem('pageName','');
    this.ROEMasterForm = this.formBuilder.group({
      // selectFromCountry: [''],
      // selectToCountry: [''],
      txtFromCurrency: ['', [Validators.required, Validators.pattern('^[A-Z]{3,6}$')]],
      txtToCurrency: ['', [Validators.required, Validators.pattern('^[A-Z]{3,6}$')]],
      txtRoeValue: ['', [Validators.required, Validators.pattern('^[-+]?[0-9]+[.]?[0-9]*([eE][-+]?[0-9]+)?$')]]
    });

    this.dtOptions = {
      dom: 'frtip',
      "pageLength": 50
    };

    /* let tmpUserType = this.cookie.get('userProfile'); */
    let tmpUserType = window.localStorage.getItem('userProfile');
    const getUserType = this.commonService.decryptData(tmpUserType);
    this.isViewMode = ((getUserType || '').toLowerCase() == 'adminview');

    // this.loadCountryList();
    this.loadRoeMasterDetails();
  }

  get f() { return this.ROEMasterForm.controls; }

  /*
  * Created By : Keerthana
  * Description : This function will fetch the country list.
  *********************************************/

  async loadCountryList() {
    let fetchCountryUrl = this.commonVariablesService.baseURL + 'api/v1/marine_master/fetchall/country';
    let fetchCountryData = await this.commonService.httpGetMethod(fetchCountryUrl, 'application/x-www-form-urlencoded', true, '', 'ROE Master');
    this.countryList = [];

    for (let i = 0; i < fetchCountryData.data.length; i++) {
      this.countryList.push({ 'country_id': fetchCountryData.data[i].country_id, 'country_name': fetchCountryData.data[i].country_name });
    }
  }

  /*
  * Created By : Keerthana
  * Description : This function will fetch the details of roe master.
  *********************************************/

  async loadRoeMasterDetails() {
    this.spinner.show();
    let table = $('#RoeMasterDatatable').DataTable();
    table.destroy();
    let fetchUrl = this.commonVariablesService.baseURL + 'api/v1/marine_master/fetchall/roe';
    let tblData = await this.commonService.httpGetMethod(fetchUrl, 'application/x-www-form-urlencoded', true, '', 'ROE Master');
    this.displayRoeMasterResponse = [];

    if (tblData.status == 0) {
      for (var i = 0; i < tblData.data.length; i++) {
		  tblData.data[i].u_ts = this.datePipe.transform(new Date(tblData.data[i].u_ts+" GMT").toISOString(),"dd-MM-yyyy HH:mm:ss")
        this.displayRoeMasterResponse.push(tblData.data[i]);
      }
    }
    else if (tblData.status != -114) {
      this.commonService.errorsmsg('Fetch Error', 'Error');
    }

    $('#searchFromCountry,#searchToCountry,#searchFromCurrency,#searchToCurrency,#searchRoeValue,#searchUpdatedBy,#searchUpdatedTime').val('');
    this.dtTrigger.next();
  }

  /*
  * Created By : Keerthana
  * Description : This function will add the details in roe master.
  *********************************************/

  async addRoeMasterDetails() {
    
    let ret = await this.checkRoeMasterData();
    if (!ret) return;
    
    this.spinner.show();
    let addUrl = this.commonVariablesService.baseURL + 'api/v1/marine_master/add/roe';
    let param = new HttpParams()
      // .set('from_country', this.ROEMasterFormValue.selectFromCountry || '')
      // .set('to_country', this.ROEMasterFormValue.selectToCountry || '')
      .set('from_currency', this.ROEMasterFormValue.txtFromCurrency)
      .set('to_currency', this.ROEMasterFormValue.txtToCurrency)
      .set('roe_value', this.ROEMasterFormValue.txtRoeValue)

    let addResponse = await this.commonService.httpPostMethod(addUrl, param, 'application/x-www-form-urlencoded; charset=UTF-8', true, 'ROE Master');

    if (addResponse.body.status == 0) {
      this.commonService.successmsg('ROE master data added successfully', 'Success');
      this.loadRoeMasterDetails();
      this.resetForm();
    }
    else {
      if (addResponse.body.status != -114) {
        let tmp = (addResponse.body.data).split(' ');

        if (tmp[0] == 'Duplicate')
          this.commonService.errorsmsg('From Currency and To Currency already exist', 'Error');
        else
          this.commonService.errorsmsg('Unable to add ROE master data', 'Error');
      }
    }
  }

  /*
  * Created By : Keerthana
  * Description : This function will edit the details in roe master.
  *********************************************/

  editRoeMasterDetails(oldResponse) {
    this.btnAddShow = true;
    this.btnUpdateShow = false;
    this.ROEMasterForm.patchValue({
      // selectFromCountry: oldResponse.from_country,
      // selectToCountry: oldResponse.to_country,
      txtFromCurrency: oldResponse.from_currency,
      txtToCurrency: oldResponse.to_currency,
      txtRoeValue: oldResponse.roe_value
    });

    this.roeID = oldResponse.roe_id;
  }

  /*
  * Created By : Keerthana
  * Description : This function will update the details in roe master.
  *********************************************/

  async updateRoeMasterDetail() {

    let ret = await this.checkRoeMasterData();
    if (!ret) return;
    
    this.spinner.show();
    let updateUrl = this.commonVariablesService.baseURL + 'api/v1/marine_master/update/roe';
    let updateParam = new HttpParams()
      // .set('from_country', this.ROEMasterFormValue.selectFromCountry || '')
      // .set('to_country', this.ROEMasterFormValue.selectToCountry || '')
      .set('from_currency', this.ROEMasterFormValue.txtFromCurrency)
      .set('to_currency', this.ROEMasterFormValue.txtToCurrency)
      .set('roe_value', this.ROEMasterFormValue.txtRoeValue)
      .set('id', this.roeID)

    let updateResponse = await this.commonService.httpPostMethod(updateUrl, updateParam, 'application/x-www-form-urlencoded; charset=UTF-8', true, 'ROE Master');

    if (updateResponse.body.status == 0) {
      this.commonService.successmsg('ROE master data updated Successfully', 'Success');
      this.loadRoeMasterDetails();
      this.resetForm();
    }
    else {
      if (updateResponse.body.status != -114) {
        let tmp = (updateResponse.body.data).split(' ');

        if (tmp[0] == 'Duplicate')
          this.commonService.errorsmsg('From Currency and To Currency already exist', 'Error');
        else
          this.commonService.errorsmsg('Unable to update ROE master data', 'Error');
      }
    }
  }

  /*
  * Created By : Keerthana
  * Description : This function will delete the details in roe master.
  *********************************************/

  async deleteRoeMasterDetails(data) {
    let status = await this.commonService.deleteAlertMsg()
    if (status) {
      this.spinner.show();
      let url = this.commonVariablesService.baseURL + 'api/v1/marine_master/delete/roe/' + data.roe_id;
      let response = await this.commonService.httpPostMethod(url, '', 'application/x-www-form-urlencoded; charset=UTF-8', true, 'Group Master');

      if (response.body.status == 0) {
        this.commonService.warningmsg('ROE master data deleted successfully', 'Worning');
        this.loadRoeMasterDetails();
        this.resetForm();
      }
      else if (response.body.status != -114) {
        this.commonService.errorsmsg('Unable to delete ROE master data', 'Error');
      }
    }
  }

  /*
  * Created By : Keerthana
  * Description : This function will reset the form.
  *********************************************/

  resetForm() {
    this.ROEMasterForm.reset();
    this.submitted = false;
    this.btnAddShow = false;
    this.btnUpdateShow = true;
  }

  /*
  * Created By : Keerthana
  * Description : This function will filter datatable according to search.
  *********************************************/

  filterBySearch() {
    // let searchFromCountry = $("#searchFromCountry").val().toString().toLowerCase();
    // let searchToCountry = $("#searchToCountry").val().toString().toLowerCase();
    let searchFromCurrency = $("#searchFromCurrency").val().toString().toLowerCase();
    let searchToCurrency = $("#searchToCurrency").val().toString().toLowerCase();
    let searchRoeValue = $("#searchRoeValue").val().toString().toLowerCase();
    let searchUpdatedBy = $("#searchUpdatedBy").val().toString().toLowerCase();
    let searchUpdatedTime = $("#searchUpdatedTime").val().toString().toLowerCase();

    let table = $("#RoeMasterDatatable").DataTable();
    table.search('').columns().search('').draw();
    /*if (searchFromCountry != "") 
    {
      table.column(0).search(searchFromCountry).draw();
    }
    if (searchToCountry != "") 
    {
      table.column(1).search(searchToCountry).draw();
    }*/
    if (searchFromCurrency != "") {
      table.column(0).search(searchFromCurrency).draw();
    }
    if (searchToCurrency != "") {
      table.column(1).search(searchToCurrency).draw();
    }
    if (searchRoeValue != "") {
      table.column(2).search(searchRoeValue).draw();
    }
    if (searchUpdatedBy != "") {
      table.column(3).search(searchUpdatedBy).draw();
    }
    if (searchUpdatedTime != "") {
      table.column(4).search(searchUpdatedTime).draw();
    }
  }
  
  exportExcel()
	{
	   var tmpArray=[];
	   var tmpObj={};
	   
	   if(this.displayRoeMasterResponse.length>0)
	   {
		 for(var i=0;i<this.displayRoeMasterResponse.length;i++)
		 {
			tmpObj={};
			tmpObj['from_currency']=this.displayRoeMasterResponse[i].from_currency;
			tmpObj['to_currency']=this.displayRoeMasterResponse[i].to_currency;
			tmpObj['roe_value']=this.displayRoeMasterResponse[i].roe_value;
			tmpObj['author']=this.displayRoeMasterResponse[i].author;
			tmpObj['u_ts']=this.displayRoeMasterResponse[i].u_ts;
			tmpArray.push(tmpObj)
		 }
		 var datajson= { datajson1: tmpArray };

		 var Heading = [
		   [],
		   ["ROE Master"],
		   [],
		   ["From Currency","To Currency","ROE Value","Updated By","Updated Time"]
		 ];

		 const merge = [
			 { s: { r: 0, c: 0 }, e: { r: 0, c: 6 } },
			 { s: { r: 1, c: 0 }, e: { r: 1, c: 6 } },
			 { s: { r: 2, c: 0 }, e: { r: 2, c: 6 } },
			 /* { s: { r: 3, c: 0 }, e: { r: 3, c: 3 } }, */
		 ];
		 
		 var wscols = [];
		 //let cell;
		 for (let idx = 0; idx < Heading[3].length; idx++) 
		 {
			 wscols.push({ wch: 25 });  // Common column width
		 }
		 var ws = XLSX.utils.json_to_sheet(Heading);
		 ws['!cols'] = wscols;
		 ws["!merges"] = merge;
		 ws["A1"] = {
			 "t": 's',
			 /* "v": 'TATA MARINE', */
			 "s": { font: { size: 20, bold: true, color: "#e012e0", style: "text-align:center"} }
		 };
		 XLSX.utils.sheet_add_json(ws, datajson.datajson1, {
			 /* header: ["group_name","author","u_ts"], */
			 skipHeader: true,
			 origin: -1
		 });
		 // var alphabets = [''];
		 var wb = XLSX.utils.book_new();
		 XLSX.utils.book_append_sheet(wb, ws, "ROE Master");
		 XLSX.writeFile(wb, 'ROE_Master.xlsx');
	   }
	   else
	   {
		this.commonService.errorsmsg("Unable to download excel,No data available in the table","Error"); 
	   }
   }
  
   /*
  * Created By : Sharann
  * Description : check the data before add/update.
  *********************************************/
  async checkRoeMasterData() {

    if (this.ROEMasterForm.invalid) {
      this.submitted = true;
      return false;
    }
    else {
      this.ROEMasterFormValue = this.ROEMasterForm.value;

      if ((this.ROEMasterFormValue.txtFromCurrency).trim() == "") {
        this.commonService.errorsmsg('Invalid Parameter, Missing From Currency', 'Error');
        return false;
      }
      else if ((this.ROEMasterFormValue.txtToCurrency).trim() == "") {
        this.commonService.errorsmsg('Invalid Parameter, Missing To Currency', 'Error');
        return false;
      }
      else if (((this.ROEMasterFormValue.txtRoeValue).toString()).trim() == "") {
        this.commonService.errorsmsg('Invalid Parameter, Missing ROE value', 'Error');
        return false;
      }
      /* if ((this.ROEMasterFormValue.selectFromCountry).trim() == (this.ROEMasterFormValue.selectToCountry).trim())
      {
        this.commonService.errorsmsg('From Country and To Country should not be same','Error');
        return;
      } */
      /* if ((this.ROEMasterFormValue.txtFromCurrency).trim() == (this.ROEMasterFormValue.txtToCurrency).trim()) {
        this.commonService.errorsmsg('From Currency and To Currency should not be same', 'Error');
        return;
      } */
      
      return true;

    }
  }

}